import { render, staticRenderFns } from "./addVenue.vue?vue&type=template&id=5a2bc1c0&scoped=true&"
import script from "./addVenue.vue?vue&type=script&lang=js&"
export * from "./addVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2bc1c0",
  null
  
)

export default component.exports